import isNil from 'lodash/isNil'
import { isValidEmail } from '@ztechapps/common.utils'

/**
 * It handles the validation of the form
 * @returns {{}}
 */
export const validate = (values) => {
  const errors: any = {}

  //user name validation
  if (values.username) {
    //it is not empty so validate if this is a valid email
    //username is also an email address so should validate if valid email address
    if (!isValidEmail(values.username)) {
      errors.username = 'Invalid email address.'
    }
  } else {
    errors.username = 'Required.'
  }

  //full name validation
  if (!values.fullName) {
    errors.fullName = 'Required.'
  }

  //password validation
  //when the password is null, the  user did not provide it, so it is fine
  //but when the user provides value and then set it as blank throw error
  if (!isNil(values.password)) {
    if (!values.password) {
      errors.password = 'Required.'
    } else {
      if (values.password.length < 6) {
        errors.password = 'Password must be at least 6 characters.'
      }
    }
  }

  return errors
}
